export default __webpack_public_path__ + "static/media/Ellipse16.749334b6.png";